// extracted by mini-css-extract-plugin
export default {"root":"IconPlus_root__J1pRK","open":"IconPlus_open__iVcvo"};